export const Colors = {
    FG_1: "#353535",
    FG_2: "#8C9398",
    BG_1: "white",
    BG_2: "#F3F5F8",
    ACCENT: "#E35F53",
};
